export const FRUITS = [
  'apple',
  'banana',
  'cherry',
  'durian',
  'eggplant',
  'fig',
  'grape',
  'honeydew',
];
